<template>
    <div class="optpl-selected-filters" v-if="this.filtersStore.selectedFilters.length">
        <div class="optpl-selected-filters__item" v-for="item in this.filtersStore.selectedFilters">
            {{ item.group.title_singular }} is
            <strong>{{ item.filter.title }}</strong>
            <a href="#" @click.prevent="deselectFilter(item)">×</a>
        </div>

        <!-- <div class="optpl-selected-filters__item-alt" v-for="item in this.filtersStore.selectedFilters">
            {{ item.group.title }}:
            <strong>{{ item.filter.title }}</strong>
            <a href="#" @click.prevent="deselectFilter(item)">×</a>
        </div> -->
    </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useFiltersStore } from "../../store/filters"

export default {
    computed: {
        ...mapStores(useFiltersStore)
    },
    data() {
        return {
            filtersStore: useFiltersStore()
        }
    },
    methods: {
        deselectFilter(item) {
            this.filtersStore.filterGroups.forEach(group => {
                if (group.id === item.group.id) {
                    group.filters.forEach(filter => {
                        if (filter.id === item.filter.id) {
                            filter.checked = false
                        }
                    })
                }
            })

            this.$emit('filter')
        }
    }
}
</script>

<style scoped>
.optpl-selected-filters {
    font-size: 12px;
    margin: 0 0 40px 0;
}

.optpl-selected-filters__item {
    display: inline-block;
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 8px;
    background: #fff;
    margin: 0 10px 10px 0;
}

.optpl-selected-filters__item strong {
    font-weight: 600;
}

.optpl-selected-filters__item a {
    color: #666;
    font-size: 13px;
    font-weight: bold;
    margin-left: 8px;
}

.optpl-selected-filters__item-alt {
    display: inline-block;
    color: #fff;
    background: #aaa;
    border-radius: 4px;
    padding: 2px 8px;
    margin: 0 10px 10px 0;
}

.optpl-selected-filters__item-alt a {
    color: #666;
    font-size: 13px;
    font-weight: bold;
    margin-left: 8px;
}
</style>
